import { render, staticRenderFns } from "./TeacherWorkLoadAvg.vue?vue&type=template&id=b370d880"
import script from "./TeacherWorkLoadAvg.vue?vue&type=script&lang=js"
export * from "./TeacherWorkLoadAvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports